<card
    [showEditSaveButton]="false"
    [mode]="'view'"
    [isLoading]="patientResource.isLoading()"
    [title]="'Patient Information'"
    [showCancelButton]="false"
>
    <card-view-mode-content>
        @if (patientResource.value(); as patient) {
            <div class="flex flex-col gap-medpace">
                <div class="flex flex-row items-center gap-medpace">
                    <medpace-labeled-text [label]="'Patient Name'" [text]="patientName()" />
                    @if (isMinor()) {
                        <mds-tag
                            class="primary-tag"
                            variant="category"
                            label="Minor"
                            categoryIcon="escalator_warning"
                        />
                    }
                </div>
                <medpace-labeled-text [label]="'Patient ID'" [text]="patient.personalInfo.patientNum" />

                @if (canViewPcsId()) {
                    <medpace-labeled-text [label]="'PCS ID'" [text]="patient.personalInfo.pcsId" />
                }

                <div class="flex flex-row gap-medpace">
                    <mds-button
                        [id]="'patient-profile-btn'"
                        color="primary"
                        [variant]="'outline'"
                        label="Patient profile"
                        icon="recent_actors"
                        (clickEvent)="profileLinkClicked()"
                    />
                    <mds-button
                        [id]="'patient-activity-btn'"
                        color="primary"
                        [variant]="'outline'"
                        label="Patient activity"
                        icon="poll"
                        (clickEvent)="activityLinkClicked()"
                    />
                </div>

                @if (caregivers()?.length > 0) {
                    <div class="flex flex-col gap-medpace">
                        @if (primaryCaregiver(); as primary) {
                            <medpace-labeled-text
                                [label]="'Primary Caregiver'"
                                [textLines]="[getCaregiverFullName(primary), primary.relationship ?? '']"
                            />
                            <mds-button
                                [id]="'view-primary-caregiver-profile-btn'"
                                color="primary"
                                [variant]="'outline'"
                                label="View profile"
                                (clickEvent)="onViewCaregiver(primary)"
                            />
                        }
                        @if (otherCaregivers(); as others) {
                            @if (others.length > 0) {
                                <mds-expansion-panel
                                    [panelTitle]="'Other caregivers'"
                                    [expanded]="others.length === 1"
                                    [description]="''"
                                    [disabled]="false"
                                    [hideToggle]="false"
                                    [enableCheckbox]="false"
                                >
                                    <div class="flex flex-col gap-medpace">
                                        @for (caregiver of others; track caregiver.id) {
                                            <medpace-labeled-text
                                                [label]="'Caregiver'"
                                                [textLines]="[
                                                    getCaregiverFullName(caregiver),
                                                    caregiver.relationship ?? '',
                                                ]"
                                            />
                                            <mds-button
                                                [id]="'view-caregiver-profile-btn-' + caregiver.id"
                                                color="primary"
                                                [variant]="'outline'"
                                                label="View profile"
                                                (clickEvent)="onViewCaregiver(caregiver)"
                                            />
                                        }
                                    </div>
                                </mds-expansion-panel>
                            }
                        }
                    </div>
                } @else {
                    <span class="italic text-gray-500">No caregivers have been added for this patient.</span>
                }
            </div>
        }
    </card-view-mode-content>
</card>
